import React from 'react';
import PropTypes from 'prop-types';
import { capitalize, getLabel } from '../../../../utils/string';

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
/**
 * Network Icon
 *
 * @namespace
 * @memberOf Common.Components.DisplayItems.Elements
 */
class ItemNetworkIcon extends React.Component {
  constructor(props) {

    super(props);
  }
  render() {
    return (
      <div className="xIconContainer">
        <i className={`xIcon xSourceLogo xIcon${capitalize(this.props.network)}`}/>
      </div>
    )
  }
}

ItemNetworkIcon.propTypes = {
  network: PropTypes.string.isRequired
}

export default ItemNetworkIcon;
